import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import {
  Backdrop,
  Box,
  Modal,
  Typography,
  ClickAwayListener,
} from '@mui/material';
import { WithTranslation, withTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';

import MapContent from './MapContent';
import { ToolsIcon } from '@icons';
import {
  EventAssetType,
  IEventAsset,
} from '@providers/EventProvider/interfaces';
import EventAssetsService from '@services/EventAssetsService';
import { MytaverseLogger } from '@helpers/logger';
import { getCatchErrorMessage } from '@helpers/error';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { useMapModal } from '@core/dashboard/components/MapModal/context/context';

import { useStyles } from './styles';

const MapModal = ({ t: translate }: WithTranslation) => {
  const classes = useStyles();

  const { currentEventId } = useMytaverseEvent();

  const { open, toggleOpen, setOpen } = useMapModal();
  const [assets, setAssets] = useState<IEventAsset[]>([]);

  // useEffect(() => {
  //   const handleKeyPress = (event: KeyboardEvent) => {
  //     if (event.key === 'm' || event.key === 'M') {
  //       setOpen(!open);
  //     }
  //   };
  //
  //   document.addEventListener('keydown', handleKeyPress);
  //
  //   return () => {
  //     document.removeEventListener('keydown', handleKeyPress);
  //   };
  // }, [open]);

  useAsyncEffect(async () => {
    try {
      const { assets } = await EventAssetsService.getAssets({
        eventId: currentEventId,
        type: EventAssetType.HUB_MAP,
      });

      assets.sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
      );

      setAssets(assets);
    } catch (e) {
      MytaverseLogger.log(`fetch Hub Map: ${getCatchErrorMessage(e)}`);
    }
  }, [currentEventId]);

  return (
    <Modal
      sx={classes.root}
      open={open && assets.length > 0}
      components={{ Backdrop }}
    >
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Box component="div" sx={classes.container}>
          <CloseIcon sx={classes.closeIcon} onClick={toggleOpen} />
          <Typography sx={classes.title}>
            {translate('mapModal.title')}
          </Typography>
          <Box sx={classes.content}>
            <MapContent maps={assets} />
          </Box>
          <Box sx={classes.actions}>
            <Box sx={classes.info}>
              <span>{translate('mapModal.button1.1')}</span>
              <ToolsIcon />
              <span>{translate('mapModal.button1.2')}</span>
            </Box>
            <Box sx={classes.info}>{translate('mapModal.button2')}</Box>
          </Box>
        </Box>
      </ClickAwayListener>
    </Modal>
  );
};

export default withTranslation()(MapModal);
